var UserEditModal = (function (base) {
  __extends(UserEditModal, base);


  function UserEditModal(apiClient) {
    const self = base.call(this, apiClient) || this;
    return self;
  };


  UserEditModal.prototype.activate = function (userId) {
    const self = this;
    const isNew = !userId;
    const url = isNew ? `api/users/add` : `api/users/${userId}/edit`;

    this.loadContent(url)
      .then($modal => {

        var $form = $('form', $modal);
        FormHelper.init($form, isNew ? 'PUT' : 'POST', 'api/users');

        $('#Phone', $modal).mask('+7 (999) 999-99-99');
        $('#CompanyPhone', $modal).mask('+7 (9999) 99-99-99');

        $modal

          //Кнопка `Сохранить`
          .on('click', '[js=save]', function() {
              $modal.busy();
              $form.send()
                .then(() => self.close({ ok: true }))
                .catch(() => $modal.busy(false));
            });
      });
  };


  return UserEditModal;
}(BaseModal));
